module.exports = "<div class=divider-group> <div class=\"q-flex-row qfr-vert-center-align\"> <div class=\"col-md-3 col-xs-12\"> <div class=q-boldest> Product SKU: </div> </div> <div class=\"col-md-3 col-xs-12\"> {%- lineitem %} </div> <div class=\"col-md-3 col-xs-12\"> <div class=q-boldest> Packed Quantity: </div> </div> <div class=\"col-md-3 col-xs-12\"> <span class=\"q-pill q-pill-spacer q-pill-detail\"> {%- lineitem2 %} </span> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/amazon-fba-order/html/amazonFBALineItems.html
// module id = 1196
// module chunks = 1